import { useCallback, useState } from "react";
import { extractText, validatePDFFile } from "../utils/pdfExtractor";

export function usePdfExtractor() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const extractAll = useCallback(async (file: File) => {
    setLoading(true);
    setError(null);

    try {
      validatePDFFile(file);
      console.log("[PDF] 📄 Iniciando extração...");

      const text = await extractText(file);

      if (!text || text.trim().length === 0) {
        throw new Error(
          "O PDF não contém texto extraível. Verifique se o arquivo contém texto, não apenas imagens.",
        );
      }

      console.log(`[PDF] ✓ Extração concluída: ${text.length} caracteres`);

      return {
        text,
        filename: file.name,
        size: file.size,
      };
    } catch (err) {
      const message =
        err instanceof Error ? err.message : "Erro ao extrair PDF";
      console.error("[PDF] ✗ Erro:", err);
      setError(message);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return { extractAll, loading, error };
}
